import { useTranslation } from 'react-i18next';
import styled from 'styled-components';

export const Wrap = styled.div`
  height: 100vh;
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;

  h2 {
    span {
      margin-left: 4px;
      font-weight: 400;
    }
  }
`;

export default function NotFound() {
  const { t } = useTranslation();
  return (
    <Wrap>
      <h2>
        404 | <span>{t('notFound')}</span>
      </h2>
    </Wrap>
  );
}
